import React from 'react'
import { Link } from 'react-router-dom'
import { ImageUrl } from '../../../../../Helpers/request'
import { LazyLoadImage } from "react-lazy-load-image-component";
import EnImg from "../../../../../Assets/img/en-img.png"
import BandImg from "../../../../../Assets/img/band-img.png"

const TwoBannerLayout = () => {
    return (
        <section>

            <div className="d-md-flex flex-xs-wrap justify-content-center position-relative align-items-center twoBanner">
                <div className="box_img">
                    <div className="picture overflow-hidden">
                        <Link to="#">
                            <LazyLoadImage src={EnImg} className="img-fluid transition" alt="Engagement Rings" />
                        </Link>
                    </div>
                </div>
                <div className="box_img">
                    <div className="picture overflow-hidden">
                        <Link to="#">
                            <LazyLoadImage src={BandImg} className="img-fluid transition" alt="Wedding Rings &amp; Bands" />
                        </Link>
                    </div>
                </div>

                <div className="banner text-center">
                    <div className="bg-banner">
                        <h3 className="title_heading">Engagement Rings Collection</h3>
                        <p className="mb-0">JUST FOR YOU</p>
                        <div className="link mt-xl-4 mt-md-3 mt-lg-3 mt-3"> <Link to="/ringsettings" className="button-banner buttonLink">Shop Engagement Rings</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TwoBannerLayout
